import { render, staticRenderFns } from "./BriqRichEditorTextarea.vue?vue&type=template&id=672935a9&scoped=true&lang=pug&"
import script from "./BriqRichEditorTextarea.vue?vue&type=script&lang=js&"
export * from "./BriqRichEditorTextarea.vue?vue&type=script&lang=js&"
import style0 from "./BriqRichEditorTextarea.vue?vue&type=style&index=0&id=672935a9&scoped=true&lang=stylus&"
import style1 from "./BriqRichEditorTextarea.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672935a9",
  null
  
)

export default component.exports